var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    borders = _ref.borders;
  return {
    bottomLabelPadding: spacing.xSmall,
    paragraphContainerMargin: spacing.xSmall,
    paragraphContainerPadding: spacing.xSmall,
    paragraphContainerColor: colors.porcelain,
    choiceContainerMargin: spacing.xSmall,
    choiceContainerContentPadding: spacing.xxSmall,
    choiceContainerContentColor: colors.porcelain,
    choicePositionWidth: spacing.large,
    choicePadding: spacing.xSmall,
    choiceBorder: borders.widthSmall,
    choiceBorderRadius: borders.radiusMedium,
    choiceColor: colors.white,
    choiceBorderColor: colors.tiara,
    choiceBodyPadding: spacing.xxxSmall,
    printedPositionInputMargin: spacing.xxSmall
  };
};
export default generateComponentTheme;